import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
`;

export const HeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 8px;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: none;
  overscroll-behavior-y: none;

  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: ${(props) => props.theme.colors.lighterGray} ${(props) =>
  props.theme.colors.highClearGray};

  /* WebKit (Chrome, Edge, Safari) */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.colors.highClearGray};
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.colors.lighterGray};
    border-radius: 3px;
  }
`;

export const ListItem = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  padding: 8px;
  height: 36px;
  gap: 8px;
  cursor: pointer;

  ${(props) =>
    !props.$isSelected &&
    `
    &:hover {
      background-color: ${props.theme.colors.ghostWhite};
      border-radius: 8px;
    }
  `}
  ${(props) =>
    props.$isSelected &&
    `
    background-color: ${props.theme.colors.titanWhite};
    border-radius: 8px;
  `}
`;

export const ListItemLabel = styled.div`
  flex: 1;
  min-width: 0;
  overflow: hidden;
`;

/** Typography from @ann/web-components renders a span; ellipsis must be on that span. */
export const TitleTextWrap = styled.div`
  width: 100%;
  min-width: 0;
  overflow: hidden;

  /* Aplicar ellipsis al span del Typography */
  & > span {
    display: inline-block;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const EditableTitleInput = styled.input`
  width: 100%;
  min-width: 0;
  padding: 8px;
  border: 0.5px solid ${(props) => props.theme.colors?.activeBlue ?? "#2173FF"};
  border-radius: 8px;
  background: #F6F9FF;
  font-size: ${(props) => props.theme.fonts?.size?.b2 ?? "14px"};
  font-family: ${(props) => props.theme.fonts?.family?.inter ?? "inherit"};
  color: ${(props) => props.theme.colors?.primary ?? "#232323"};
  outline: none;

  &::placeholder {
    color: ${(props) => props.theme.colors?.grey ?? "#666666"};
  }
`;

export const ListItemActions = styled.div`
  flex-shrink: 0;
  display: none;
  align-items: center;
  justify-content: flex-end;

  ${ListItem}:hover & {
    display: flex;
    pointer-events: auto;
  }

  & > .chat-actions > button {
    padding: 4px 0px;
  }

  & > .chat-actions > button > span > svg{
    height: 12px;
    width: auto;
  }
`;
